import { Button, colors } from '@giphy/react-giphy-brand'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { connect } from 'react-redux'
import GridTypeContext from 'shared/components/context/grid-type'
import GridTypeToggle from 'shared/components/grid-type/grid-type'
import channelProps from 'shared/prop-types/channel'
import { bulkEditMode } from 'shared/redux/bulk-edit-mode'
import * as selectors from 'shared/redux/reducers'
import { getTvUrlFromChannel, openTvFromChannel } from 'shared/util/tv'
import styled from 'styled-components'
import css from './navigation.css'

const { number, string } = PropTypes

const BulkEditorButton = styled(Button)`
    height: 32px;
    width: 140px;
    line-height: 32px;
    font-weight: bold;
`

/**
 * Channel Grid - Navigation: Controls channel search,
 * view modes, and tv popout.
 *
 * @class GridNavigation
 */
const Navigation = ({ user, isOwner, channel, title, tvRatio = 16 / 9, isBulkEditMode, bulkEditMode }) => {
    const { gridType } = useContext(GridTypeContext)
    const showBulkEditor =
        gridType === 'grid' && user && user.loggedIn && user.permissions.bulk_edit && (user.isStaff || isOwner)
    return (
        <div className={css.container}>
            <h2 className={css.title}>{title}</h2>
            <div className={css.items}>
                {showBulkEditor && (
                    <BulkEditorButton color={colors.giphyDarkestGrey} onClick={() => bulkEditMode(!isBulkEditMode)}>
                        Bulk Editor
                    </BulkEditorButton>
                )}
                <GridTypeToggle />
                {channel.user && channel.user.is_verified && (
                    <a
                        className={css.tv}
                        href={getTvUrlFromChannel(channel)}
                        onClick={e => {
                            e.preventDefault()
                            openTvFromChannel(channel, tvRatio)
                        }}
                    />
                )}
            </div>
        </div>
    )
}

Navigation.propTypes = {
    channel: channelProps,
    title: string,
    tvRatio: number,
}

export default connect(
    state => ({
        isBulkEditMode: selectors.getIsBulkEditMode(state),
        user: selectors.getUser(state),
    }),
    { bulkEditMode }
)(Navigation)
